<template>
  <div>
    <table-list
      title="考试试卷"
      :loading="loading"
      :search-form="searchForm(this)"
      :data="examPaperList"
      :btns="btns(this)"
      :footer-btns="footerBtns(this)"
      :columns="columns(this)"
      :operates="operates(this)"
      :pager="pager"
      :options="{ selection: true, operatesWidth: 480 }"
      @search="onSearch"
      @selectionChange="handleSelectionChange"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
    <PlanRelation ref="PlanRelation" />
    <BankImportDialog ref="BankImportDialog" @success="getExamPaper" />
    <el-dialog title="导入试题" :visible.sync="importVisible" width="420px">
      <el-upload
        action=""
        :http-request="importQuestion"
        accept=".xls,.xlsx"
        :limit="1"
        :file-list="fileList"
      >
        <el-button type="primary">试题导入</el-button>
      </el-upload>
    </el-dialog>
  </div>
</template>
<script>
// 顶部按钮
const btns = _this => [
  {
    label: '增加',
    icon: 'el-icon-circle-plus-outline',
    method: _this.handleAdd,
  },
  {
    label: '下载导入模板',
    icon: 'el-icon-document',
    method: _this.handleDownloadTemp,
  },
  {
    label: '删除',
    icon: 'el-icon-delete',
    method: _this.handleDelete,
  },
]
// 底部按钮
const footerBtns = _this => [
  {
    label: '导出全部',
    icon: 'el-icon-download',
    method: _this.exportTable,
  },
]
// 搜索框配置
const searchForm = _this => [
  {
    label: 'ID/试卷名称',
    prop: 'nameFilter',
  },
  {
    label: '类型',
    type: 'select',
    prop: 'paperType',
    children: [
      { value: '1', label: '实操' },
      { value: '2', label: '理论' },
    ],
  },
  {
    label: '状态',
    type: 'select',
    prop: 'paperStatus',
    children: [
      { value: '1', label: '编辑中' },
      { value: '2', label: '已发布' },
    ],
  },
  {
    label: '创建时间',
    type: 'picker',
    prop: 'createTime',
  },
  {
    label: '创建人',
    type: 'select',
    prop: 'createUserId',
    children: _this.adminList.map(item => ({
      value: item.key,
      label: item.value,
    })),
  },
]
// 表格列配置
const columns = _this => [
  {
    prop: 'id',
    label: '试卷ID',
    minWidth: 70,
  },
  {
    prop: 'paperTitle',
    label: '试卷名称',
    minWidth: 180,
    twoLines: true,
  },
  {
    prop: 'paperTypeStr',
    label: '适用类型',
    minWidth: 80,
  },
  {
    prop: 'jobLevel',
    label: '适用等级',
    minWidth: 80,
  },
  {
    prop: 'workType',
    label: '适用工种',
    minWidth: 120,
  },
  {
    prop: 'paperJob',
    label: '适用职业',
    minWidth: 160,
  },
  {
    prop: 'description',
    label: '描述',
    twoLines: true,
    minWidth: 140,
  },
  {
    prop: 'paperStatusStr',
    label: '状态',
    minWidth: 70,
  },
  {
    prop: 'questionTotal',
    label: '题目数',
    minWidth: 70,
  },
  {
    prop: 'beginTime',
    label: '关联计划',
    minWidth: 80,
    render: (h, { row }) => {
      return [
        h(
          'el-button',
          {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                _this.handlePlan(row)
              },
            },
          },
          '查看',
        ),
      ]
    },
  },
  {
    prop: 'createUserName',
    label: '创建人',
    minWidth: 70,
  },
  {
    prop: 'createTime',
    label: '创建时间',
    sortdata: 1,
    minWidth: 150,
  },
  {
    prop: 'questionConfigStr',
    label: '抽题方式',
    sortdata: 1,
    minWidth: 100,
  },
  {
    prop: 'variantCount',
    label: '试卷种类',
    sortdata: 1,
    minWidth: 100,
  },
]
// 表格操作按钮配置
const operates = _this => [
  {
    method: _this.handleEditStatus,
    label: '发布',
    isShow: item => item.paperStatus == 1,
  },
  {
    method: _this.handleEditStatus,
    label: '取消发布',
    isShow: item => item.paperStatus == 2 && !item.relatedPlanNum,
  },
  {
    method: _this.handleEdit,
    label: '编辑',
    isShow: item => item.paperStatus == 1,
  },
  {
    method: _this.handleTest,
    label: '测试',
  },
  {
    method: _this.handleDesign,
    label: '自定义试题',
    isShow: item => item.paperStatus == 1,
  },
  {
    method: _this.handleImport,
    label: '导入试题',
    isShow: item => item.paperStatus == 1,
  },
  {
    method: _this.handleBankImport,
    label: '题库导入',
    isShow: item => item.paperStatus == 1,
  },
  {
    method: _this.handleConfig,
    label: '配置试卷',
    isShow: item => item.paperStatus == 1,
  },
]
import TableList from '@/components/TableList'
import PlanRelation from './components/PlanRelation.vue'
import BankImportDialog from './components/BankImportDialog.vue'
import {
  examPaperList,
  examPaperRemove,
  examPaperExport,
  examPaperStatusEdit,
  filterAdminList,
  examPaperTempDownload,
  examPaperQuestionImport,
} from '@/api/exam'
import to from 'await-to'
export default {
  name: 'ExamItems',
  components: {
    TableList,
    PlanRelation,
    BankImportDialog,
  },
  data() {
    return {
      searchForm,
      btns,
      footerBtns,
      columns,
      operates,
      loading: false,
      examPaperList: [],
      selectPaperList: [],
      pager: {
        total: 0,
        size: 20,
        current: 1,
      },
      queryParams: {},
      planDialogVisible: false,
      adminList: [],
      importPaperId: '',
      importVisible: false,
      fileList: [],
    }
  },
  mounted() {
    this.getExamPaper()
    this.getAdminList()
  },
  methods: {
    async getExamPaper() {
      if (this.loading) return
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(examPaperList({ current, size, ...this.queryParams }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.examPaperList = res.data.list
      this.pager.total = res.data.total
    },
    async getAdminList() {
      const [res, err] = await to(filterAdminList({}))
      if (err) return this.$message.warning(err.msg)
      this.adminList = res.data
    },
    async exportTable() {
      let arr = []
      if (this.selectPaperList.length) this.selectPaperList.map(v => arr.push(v.id))
      const { current, size } = this.pager
      const [res, err] = await to(
        examPaperExport({
          current,
          size,
          idList: arr,
          ...this.queryParams,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      let blob = new Blob([res], {
        type: 'application/vnd.ms-excel',
      })
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = '考试试卷.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    // 查询按钮
    onSearch(queryParams) {
      this.pager.current = 1
      this.queryParams = queryParams
      if (queryParams.createTime && queryParams.createTime.length) {
        queryParams.start = queryParams.createTime[0]
        queryParams.end = queryParams.createTime[1].split(' ')[0] + ' 23:59:59'
      } else {
        queryParams.start = undefined
        queryParams.end = undefined
      }
      this.getExamPaper()
    },
    handleDesign(row) {
      this.$router.push({ path: '/exam/paper/design', query: { id: row.id } })
    },
    // 编辑
    handleEdit(row) {
      this.$router.push({ path: `/exam/paper/${row.id}` })
    },
    async handleEditStatus({ id }) {
      const [, err] = await to(examPaperStatusEdit({ id }))
      if (err) return this.$message.warning(err.msg)
      this.getExamPaper()
    },
    // 删除
    async handleDelete() {
      if (this.selectPaperList.length == 0) {
        return this.$message.warning('请先选择要删除的试卷')
      }
      this.$confirm('你确认要删除吗?', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          let idList = []
          this.selectPaperList.map(v => idList.push(v.id))
          const [, err] = await to(examPaperRemove({ idList }))
          if (err) return this.$message({ type: 'error', message: err.msg })
          this.$message({ type: 'success', message: '删除成功' })
          this.getExamPaper()
        })
        .catch(() => {})
    },
    handleAdd() {
      this.$router.push({ path: '/exam/paper/add' })
    },
    handleTest(row) {
      this.$router.push({ path: '/exam/testPaper', query: { id: row.id } })
    },
    handlePlan(row) {
      this.$refs.PlanRelation.show(row.id)
    },
    handleImport(row) {
      this.importPaperId = row.id
      this.importVisible = true
    },
    // 题库导入
    handleBankImport(row) {
      this.$refs.BankImportDialog.show(row.id)
    },
    // 配置试卷
    handleConfig(row) {
      this.$router.push({ path: '/exam/paper/config', query: { id: row.id } })
    },
    async handleDownloadTemp() {
      const [res, err] = await to(examPaperTempDownload())
      if (err) return this.$message.error(err.msg)
      let blob = new Blob([res], {
        type: 'application/vnd.ms-excel',
      })
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = '试卷模板.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getExamPaper()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getExamPaper()
    },
    handleSelectionChange(val) {
      this.selectPaperList = val
    },
    async importQuestion(file) {
      const params = new FormData() //创建FormData
      params.append('file', file.file)
      params.append('paperId', this.importPaperId)
      const [, err] = await to(examPaperQuestionImport(params))
      this.fileList = []
      if (err) return this.$message.warning(err.msg)
      this.$message({
        message: '导入成功',
        type: 'success',
      })
      this.importVisible = false
      this.getExamPaper()
    },
  },
}
</script>
